import React, { useMemo } from 'react'
import { useParams } from 'react-router'
import { useEventSlug, useQuery } from 'hooks'
import FullPageLoading from 'components/FullPageLoading'
import { PerformerType, SearchPerformersQuery, SearchPerformersQueryVariables } from 'generated/graphql'
import { getNodes } from 'graphql/utils'
import { performersQuery } from './graphql/query'
import SpeakerEditor from './SpeakerEditor'

const UpdateSpeaker = () => {
    const eventSlug = useEventSlug()
    const { id: speakerId } = useParams<{ id: string }>()

    const { data: speakerNodes, requestStatus } = useQuery<
        SearchPerformersQuery, SearchPerformersQueryVariables
    >(performersQuery, { eventId: eventSlug, first: 1, filters: { id: +speakerId } })

    const speaker = useMemo<PerformerType>(
        () => (speakerNodes ? getNodes(speakerNodes.event.performers)[0] : null) as PerformerType,
        [speakerNodes]
    )

    if (requestStatus === 'loading') {
        return <FullPageLoading />
    }

    return <SpeakerEditor speaker={speaker} />
}

export default UpdateSpeaker
